import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import BrickCanvas from "./BrickCanvas";
import { BRICK_THEMES, ThemeKey } from "./bricks";
import GamesSection from "./GamesSection";
import { ChevronDown } from "./games/icons";
import LanguageSwitcher from "./LanguageSwitcher";

// Pick a design direction with ?theme=toy|night|blueprint (defaults to toy).
function useTheme(): ThemeKey {
  const param = useSearchParams()[0].get("theme");
  return param && param in BRICK_THEMES ? (param as ThemeKey) : "toy";
}

// Page color per theme: shown when the page is dragged past its ends, and used to tint the
// browser's toolbar on phones.
const PAGE_COLOR: Record<ThemeKey, string> = { toy: "#f4f1ea", night: "#14161f", blueprint: "#1f4fa0" };
const DEFAULT_PAGE_COLOR = PAGE_COLOR.toy;

function usePageColor(color: string) {
  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');
    document.documentElement.style.backgroundColor = color;
    meta?.setAttribute("content", color);
    return () => {
      document.documentElement.style.backgroundColor = "";
      meta?.setAttribute("content", DEFAULT_PAGE_COLOR);
    };
  }, [color]);
}

function Landing() {
  const theme = useTheme();
  usePageColor(PAGE_COLOR[theme]);
  const { t } = useTranslation();
  return (
    <div className={`landing theme-${theme}`}>
      <main className="App">
        <BrickCanvas theme={theme} />
        <div className="headline">
          <h1>
            <span className="headline__brand">BrickCity</span>{" "}
            <span className="headline__rest">{t("landing.headlineRest")}</span>
          </h1>
          <a href="#games" className="play-pill">
            {t("landing.playWhileYouWait")} <ChevronDown />
          </a>
        </div>
        <LanguageSwitcher />
      </main>
      <GamesSection />
    </div>
  );
}

export default Landing;
